import localConfig from "../env/env.local.json";
import productionConfig from "../env/env.production.json";
// import sandboxConfig from '@/../../env/env.sandbox.json'
import { Endpoints } from "./endpoints";

type BackendApiEnvProps = {
  url: string;
};

export class AppEnv {
  static isInitialized = false;
  static backendApi: BackendApiEnvProps;
  static endpoints: typeof Endpoints;

  private constructor() {
    // Prevent instantiation
  }
  private static getConfig(envName: AppEnvName) {
    // Default to LOCAL if no environment is specified
    if (!envName || envName === AppEnvName.LOCAL) {
      return localConfig;
    } else if (envName === AppEnvName.PRODUCTION) {
      return productionConfig;
    }
    // else if (envName === AppEnvName.SANDBOX) {
    // 	return sandboxConfig
    // }
    else {
      console.warn(
        `Environment ${envName} not explicitly supported, defaulting to LOCAL`
      );
      return localConfig; // Default to local config instead of throwing error
    }
  }
  static initialize() {
    if (!this.isInitialized) {
      // Get environment or default to LOCAL if not set
      // Use REACT_APP_NODE_ENV (Create React App format) or fallback to NODE_ENV or LOCAL
      let nodeEnv = (process.env.REACT_APP_NODE_ENV ||
        process.env.REACT_NODE_ENV ||
        process.env.NODE_ENV ||
        AppEnvName.LOCAL) as AppEnvName;
      console.log("nodeEnv", nodeEnv);

      // Normalize environment name
      if (nodeEnv === AppEnvName.DEVELOPMENT) {
        nodeEnv = AppEnvName.LOCAL; // Changed to LOCAL for development
      } else if (nodeEnv === AppEnvName.PRODUCTION) {
        nodeEnv = AppEnvName.PRODUCTION;
      } else {
        // Default to LOCAL for any other environment or undefined
        nodeEnv = AppEnvName.LOCAL;
      }

      try {
        Endpoints.initialize(nodeEnv);
        this.endpoints = Endpoints;
        this.loadFromJson(this.getConfig(nodeEnv));
        this.isInitialized = true;
        console.log("AppEnv initialized with environment:", nodeEnv);
      } catch (error) {
        console.error("Failed to initialize AppEnv:", error);
        // Fallback to LOCAL if there's an error
        if (nodeEnv !== AppEnvName.LOCAL) {
          console.log("Falling back to LOCAL environment");
          nodeEnv = AppEnvName.LOCAL;
          Endpoints.initialize(nodeEnv);
          this.endpoints = Endpoints;
          this.loadFromJson(this.getConfig(nodeEnv));
          this.isInitialized = true;
        } else {
          throw error; // Re-throw if we're already trying LOCAL
        }
      }
    } else {
      console.warn("AppEnv has already been initialized");
    }
  }

  private static loadFromJson(json: Record<string, any>): void {
    this.backendApi = {
      url: json.api.url,
    };
  }
}

export enum AppEnvName {
  LOCAL = "local",
  DEVELOPMENT = "development",
  PRODUCTION = "production",
  SANDBOX = "sandbox",
}

export function getAppEnv(): typeof AppEnv {
  if (!AppEnv.isInitialized) {
    AppEnv.initialize();
  }
  return AppEnv;
}
